import {USER_PROFILE} from '../../../endpoints'
import {apiPrivate} from '../../../api'
import types from '../types/email'
import {push} from 'react-router-redux'
import {endpoint as endpointText} from '../../../common/text'
import {User} from '../../../state/actions'
import loginActions from '../../login/actions/login'

export default class missingInfoEmail {

  static sendConfirmationEmail() {
    return function(dispatch) {

      dispatch({type: types.SEND_CONFIRMATION_EMAIL})

      apiPrivate.get(USER_PROFILE + '/user/resendConfirmationEmail')
        .then(response => {
          dispatch(missingInfoEmail.sendConfirmationEmailSuccess())
        }, error => {
          let message = ''
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(push('/'))
              dispatch(loginActions.open())
              dispatch(User.logOut())
              dispatch(missingInfoEmail.sendConfirmationEmailFail(message))
              return
            }
            message = error.response.data.description //TODO maybe parse this? So it does't crash if description doesn't exist
          } else if (error.request) {
            message = endpointText.internetMayBeTheProblem
          } else {
            message = endpointText.somethingWentWrong
          }
          dispatch(missingInfoEmail.sendConfirmationEmailFail(message))
        })
    }
  }

  static sendConfirmationEmailSuccess() {
    return {
      type: types.SEND_CONFIRMATION_EMAIL_SUCCESS,
    }
  }

  static sendConfirmationEmailFail(error) {
    return {
      type: types.SEND_CONFIRMATION_EMAIL_FAIL,
      payload: {
        error,
      },
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/missingInfo/actions/email.js